<template>
  <div :style="`width: ${width}`" class="multi-selection-container">
    <v-select
      :value="value"
      :items="items"
      :label="label"
      outlined
      dense
      v-bind="$attrs"
      multiple
      :no-data-text="$t('msg.noData')"
      :menu-props="{ contentClass: 'mt-10 listItem' }"
      @input="(v) => $emit('input', v)"
      :append-icon="
        $attrs.readonly === '' || $attrs.readonly ? '' : 'mdi-menu-down'
      "
      small-chips
      :rules="rules"
      ref="selectRef"
      :class="{ requiredLabel: required }"
    >
      <template v-slot:prepend-item>
        <template v-if="selectAll && items.length">
          <v-list-item ripple @mousedown.prevent @click="toggle">
            <v-list-item-action>
              <v-icon :color="value.length > 0 ? 'indigo darken-4' : ''">
                {{ icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("index.label.selectAll") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2" />
        </template>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "MultiSelectField",
  data: () => ({
    itemsSelected: [],
    isShow: false,
    hideDetails: false,
    returnObject: false,
    itemValue: "value",
    itemText: "text",
    HTMLList: null,
    myDynamicWatcher: null,
  }),
  props: {
    items: {
      type: Array,
      require: true,
    },
    label: {
      type: String,
      require: false,
    },
    value: {},
    width: {
      type: String,
    },
    blur: {
      type: Function,
    },
    // show option select all when set to true
    selectAll: {
      type: Boolean,
      default: false,
    },
    rules: {},
    required: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleBlur() {
      if (this.blur) this.blur();
    },

    get() {
      return this.value;
    },
    set(value) {
      this.$emit("input", value);
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectedAllItems) {
          this.set([]);
        } else {
          if (this.returnObject) this.set(this.items.slice());
          else this.set(this.items.map((item) => item[this.itemValue]));
        }
      });
    },
    toggleIds(item) {
      if (this.returnObject)
        this.set(
          this.value.filter(
            (item2) => item2[this.itemValue] !== item[this.itemValue],
          ),
        );
      else
        this.set(this.value.filter((item2) => item2 !== item[this.itemValue]));
      this.$nextTick(() => {
        this.handleBlur();
      });
    },
  },
  beforeDestroy() {
    this.itemsSelected = [];
  },
  computed: {
    selectedAllItems() {
      return this.items.length !== 0 && this.value.length === this.items.length;
    },
    selectedSomeItems() {
      return this.value.length > 0 && !this.selectedAllItems;
    },
    icon() {
      if (this.selectedAllItems) return "mdi-checkbox-marked";
      if (this.selectedSomeItems) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  mounted() {
    this.HTMLList = this.$el.querySelector(".v-select__selections");
    this.HTMLList.setAttribute("tabindex", 1);
    this.hideDetails =
      this.$attrs["hide-details"] || this.$attrs["hide-details"] === "";
    this.returnObject =
      this.$attrs["return-object"] || this.$attrs["return-object"] === "";
    this.itemValue = this.$attrs["item-value"] || "value";
    this.itemText = this.$attrs["item-text"] || "text";
    this.myDynamicWatcher = this.$watch(
      () => this.$refs.selectRef.isMenuActive,
      (val) => {
        if (!val) this.handleBlur();
      },
    );
  },
  destroyed() {
    this.myDynamicWatcher();
  },
};
</script>

<style lang="scss">
.multi-selection-container {
  .v-select__selections {
    margin-top: 3px !important;
    .v-chip--select {
      margin-top: 5px;
    }
  }
}
</style>
